import Assignment from '@mui/icons-material/Assignment';
import ChatOutlined from '@mui/icons-material/ChatOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import EditNote from '@mui/icons-material/EditNote';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import type { SvgIconComponent } from '@mui/icons-material';
import UpcomingOutlined from '@mui/icons-material/UpcomingOutlined';

export const CANDIDATE_TIMELINE_MESSAGE_CONTEXT = 'CANDIDATE_TIMELINE_MESSAGE_CONTEXT';

export const CANDIDATE_TIMELINE_RECORDS_ALIAS = {
  NOTE_CREATED: 'NOTE_CREATED',
  RESUME_ADDED: 'RESUME_ADDED',
  APPLICATION_CREATED: 'APPLICATION_CREATED',
  SYSTEM_NOTE: 'SYSTEM_NOTE',
  COMMUNICATION: 'COMMUNICATION',
  OFFER: 'OFFER',
  EXPECTED_COMPENSATION: 'EXPECTED_COMPENSATION',
};

const NOTE = 'Note';
const SYSTEM_NOTE = 'SystemNote';
const APPLICATION = 'Application';
const OFFER = 'Offer';
const CANDIDATE_RESUME = 'Resume';
const COMMUNICATION = 'Communication';
export const EXPECTED_COMPENSATION = 'EXPECTED_COMPENSATION';

const CANDIDATE_TIMELINE_RECORD_TYPES = {
  [NOTE]: NOTE,
  [SYSTEM_NOTE]: SYSTEM_NOTE,
  [APPLICATION]: APPLICATION,
  [OFFER]: OFFER,
  [CANDIDATE_RESUME]: CANDIDATE_RESUME,
  [COMMUNICATION]: COMMUNICATION,
  [EXPECTED_COMPENSATION]: EXPECTED_COMPENSATION,
} as const;

export type CandidateTimelineType =
  (typeof CANDIDATE_TIMELINE_RECORD_TYPES)[keyof typeof CANDIDATE_TIMELINE_RECORD_TYPES];

export const CANDIDATE_TIMELINE_ICONS: Record<CandidateTimelineType, SvgIconComponent> = {
  [NOTE]: EditNote,
  [APPLICATION]: UpcomingOutlined,
  [CANDIDATE_RESUME]: DescriptionOutlined,
  [SYSTEM_NOTE]: SettingsOutlined,
  [COMMUNICATION]: ChatOutlined,
  [OFFER]: Assignment,
  [EXPECTED_COMPENSATION]: SettingsOutlined,
} as const;

export const OFFER_OFFICES = {
  MINSK: 'MINSK',
  KRAKOW: 'KRAKOW',
};

export const CANDIDATE_TIMELINE_OFFER_STATUSES = {
  DRAFT: 'DRAFT',
  FINALIZED: 'FINALIZED',
  SENT: 'SENT',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CANCELED: 'CANCELED',
};

export const CONTRACT_TYPES = {
  EC: 'EC',
  B2B: 'B2B',
  CFS: 'CFS',
};

export const OFFER_TEMPLATE_FILE_NAMES = {
  OFFER_POLAND_B2B: 'offer-poland-b2b.md',
  OFFER_POLAND_EC: 'offer-poland-ec.md',
  OFFER_POLAND_CFS: 'offer-poland-cfs.md',
  OFFER_BELARUS: 'offer-belarus.md',
};
